<ng-template #unreserveBulkModalFormContent let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ formTitle }}</h5>
    <button type="button" class="btn-close" (click)="cancelForm()"></button>
  </div>

  <div class="modal-body">

    <div class="row mb-3">
      <div class="col-lg-12">
        <label class="form-label" for="unreserveBulkFile">Spreadsheet containing a column of ICCIDs</label>
        <input
          accept=".xlsx,.xls,.csv"
          class="form-control"
          [disabled]="unreserveInProgress"
          id="unreserveBulkFile"
          type="file"
          (change)="uploadData($event)"
        >
        @if (selectedFile != "") {
          <div class="form-text">{{ selectedFile }} - {{ iccids.length }} ICCID(s) found</div>
        }
      </div>
    </div>

    @if (uploadMessagesVisible) {
      <div class="alert alert-danger" role="alert">
        @for (message of uploadMessages; track message) {
          <div>{{ message }}</div>
        }
      </div>
    }

    @if (summaryTotal>0) {
      <div class="row mb-3">
        <div class="col-lg-12">
          <div class="alert" [class.alert-success]="summaryFailed===0" [class.alert-warning]="summaryFailed>0" role="alert">
            {{ summarySucceeded }} of {{ summaryTotal }} unreserved, {{ summaryFailed }} failed
          </div>
        </div>
      </div>
    }

    @if (results.length>0) {
      <div class="row">
        <div class="col-lg-12 table-responsive" style="max-height: 45vh; overflow-y: auto;">
          <table class="table table-sm table-striped align-middle">
            <thead>
              <tr>
                <th>ICCID</th>
                <th>Outcome</th>
                <th>Detail</th>
              </tr>
            </thead>
            <tbody>
              @for (result of results; track result.iccid) {
                <tr>
                  <td>{{ result.iccid }}</td>
                  <td><span [class]="outcomeBadgeClass(result)">{{ outcomeDescription(result) }}</span></td>
                  <td>{{ result.message }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="cancelForm()">Close</button>
    <button
      class="btn btn-danger"
      [disabled]="unreserveInProgress || iccids.length===0"
      type="button"
      (click)="confirmUnreserve()"
    >
      @if (unreserveInProgress) {
        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      }
      Unreserve {{ iccids.length }} SIM(s)
    </button>
  </div>
</ng-template>

<app-completed-modal-form #completedModalForm
></app-completed-modal-form>

<app-confirmation-modal-form #unreserveBulkConfirmationModal
  (modalYes)="yesUnreserveSims()"
></app-confirmation-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
